/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how your money grows with compound interest. Enter the principal, annual rate, time period and how often interest compounds.`)
};

const es_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve cómo crece tu dinero con interés compuesto. Ingresa el principal, tasa anual, período de tiempo y con qué frecuencia se compone el interés.`)
};

const de_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie, wie Ihr Geld mit Zinseszins wächst. Geben Sie das Kapital, den jährlichen Zinsatz, den Zeitraum und die Häufigkeit ein, mit der Zinsen zusammengesetzt werden.`)
};

const nl_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zie hoe uw geld groeit met samengestelde rente. Voer de hoofdsom, jaarlijks tarief, periode en samenstellingsfrequentie in.`)
};

const fr_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voyez comment votre argent croît avec l'intérêt composé. Entrez le principal, le taux annuel, la période et la fréquence de composition des intérêts.`)
};

const it_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi come il tuo denaro cresce con l'interesse composto. Inserisci il capitale, il tasso annuale, il periodo di tempo e quanto spesso l'interesse si capitalizza.`)
};

const pt_br2_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja como seu dinheiro cresce com juros compostos. Digite o principal, taxa anual, período de tempo e com que frequência os juros compostos.`)
};

const pt_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja como o seu dinheiro cresce com juro composto. Introduza o principal, taxa anual, período de tempo e com que frequência o juro capitaliza.`)
};

const ja_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複利でお金がどのように成長するかを確認します。元本、年率、期間、および複利頻度を入力してください。`)
};

const zh_sip_compound_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看您的资金如何通过复利增长。输入本金、年利率、时间期限以及利息复利的频率。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_compound_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_compound_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_compound_intro", locale)
	if (locale === "en") return en_sip_compound_intro(inputs)
	if (locale === "es") return es_sip_compound_intro(inputs)
	if (locale === "de") return de_sip_compound_intro(inputs)
	if (locale === "nl") return nl_sip_compound_intro(inputs)
	if (locale === "fr") return fr_sip_compound_intro(inputs)
	if (locale === "it") return it_sip_compound_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sip_compound_intro(inputs)
	if (locale === "pt") return pt_sip_compound_intro(inputs)
	if (locale === "ja") return ja_sip_compound_intro(inputs)
	return zh_sip_compound_intro(inputs)
};